import DataGrid2 from '../..';
import { IDataGridRow } from '../../entities';
import { onRowInserted } from './onRowInserted';
import { onRowUpdated } from './onRowUpdated';

export function emitRelationEvents(this: DataGrid2, row: IDataGridRow, type: 'create' | 'update') {
	if (type === 'create') {
		onRowInserted.call(this, { data: row.data });
	}

	if (type === 'update') {
		onRowUpdated.call(this, { data: row.data, key: row.data[this.getUniqueDataField()] });
	}
}
